import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LeadService } from './shared/services/lead.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  private _leadSubmitted?: Subscription;

  public isNavbarExpanded: boolean = false;
  public isToasVisible: boolean = false;

  constructor(private readonly _leadService: LeadService) {

  }

  public ngOnInit(): void {
    this._leadSubmitted = this._leadService.leadCreated$.subscribe(() => {
      this.isToasVisible = true;

      setTimeout(() => {
        this.isToasVisible = false;
      }, 2500);
    })
  }

  public ngOnDestroy(): void {
    if (this._leadSubmitted) {
      this._leadSubmitted.unsubscribe();
    }
  }
}
